import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl } from '../data/content';
import { kitOffer, kitOfferRows } from '../data/kitOffer';
export function KitPricing() {
  return <section id="planes" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-169" data-mp="3a9k20zdadlyk">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-5 md:px-8" data-id="element-170" data-mp="35hsbupy1li8y">
        <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl bg-white shadow-lg ring-2 ring-blue-600" data-id="element-171" data-mp="3j9gnks4dq4pe">
          <div className="bg-blue-900 px-6 py-8 text-center text-white md:px-10 md:py-10" data-id="element-172" data-mp="3eam3znyl8c48">
            <p className="text-xs font-extrabold uppercase tracking-widest text-blue-200 sm:text-sm" data-id="element-173" data-mp="3t7cwdd9ugnkc">
              {kitOffer.label}
            </p>
            <h2 className="mt-3 text-3xl font-extrabold leading-tight tracking-tight md:text-5xl" data-id="element-174" data-mp="3o930f0gapixo">
              {kitOffer.name}
            </h2>
            <p className="mt-2 text-lg font-semibold text-blue-100 md:text-xl" data-id="element-175" data-mp="1tuimd6mhcln9">{kitOffer.summary}</p>
          </div>

          <div className="px-5 py-6 sm:px-7 md:px-10 md:py-8" data-id="element-176" data-mp="1ajc1astillj5">
            <ul className="divide-y divide-blue-100" data-id="element-177" data-mp="1agzarr9oy2uh">
              {kitOfferRows.map(row => <li key={row.title} className="flex items-start gap-3 py-4 first:pt-0 md:gap-4" data-id="element-178" data-mp="1ei1cqfuzst05">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-179" data-mp="1jhnpko6ws78f">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-180" data-mp="1ta37jli7gvtb" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-181" data-mp="1y7v813wx1q94">
                    <p className="font-extrabold leading-snug tracking-tight text-slate-900" data-id="element-182" data-mp="1yahhj93daftz">
                      {row.title}
                    </p>
                    <p className="mt-0.5 text-sm leading-relaxed text-blue-900/70" data-id="element-183" data-mp="279b9gm5r6i17">{row.detail}</p>
                  </div>
                  <span className="mt-0.5 shrink-0 rounded-md bg-emerald-50 px-2 py-0.5 text-[11px] font-extrabold uppercase tracking-wide text-emerald-600" data-id="element-184" data-mp="7x8rjgcs1vpn">
                    {row.status}
                  </span>
                </li>)}
            </ul>

            <div className="mt-4 rounded-xl bg-blue-50 px-5 py-4 text-center ring-1 ring-blue-100" data-id="element-185" data-mp="1b7e784oztzv4">
              <p className="text-sm font-extrabold uppercase tracking-wider text-blue-800 md:text-base" data-id="element-186" data-mp="1p75lm6jf9i9n">
                {kitOffer.bundle}
              </p>
              <p className="mt-1 text-sm text-blue-900/70" data-id="element-187" data-mp="1k9nk317qi5bo">{kitOffer.bundleNote}</p>
            </div>

            <div className="mt-8 text-center" data-id="element-188" data-mp="1z2pf6maik4v8">
              <p className="text-xs font-extrabold uppercase tracking-widest text-blue-900/55 sm:text-sm" data-id="element-189" data-mp="1u6idj5p5hfj3">
                {kitOffer.priceLabel}
              </p>
              <p className="mt-1 text-7xl font-extrabold tracking-tight text-slate-900 md:text-8xl" data-id="element-190" data-mp="23vigf06rwv2k">
                {kitOffer.price}
                <span className="ml-2 text-3xl font-semibold text-blue-900/55" data-id="element-191" data-mp="2hui2q16tcxvk">
                  {kitOffer.currency}
                </span>
              </p>
              <p className="mt-1 text-sm font-bold text-emerald-600" data-id="element-192" data-mp="2cudnsflk0b7g">{kitOffer.priceNote}</p>
            </div>

            <div className="mt-6" data-id="element-193" data-mp="31h3awfkpjqnu">
              <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-194" data-mp="31g1x43cb4q2f">
                {kitOffer.cta}
              </CtaButton>
              <p className="mt-3 text-center text-sm text-blue-900/60" data-id="element-195" data-mp="2mjkin38tmvbn">{kitOffer.note}</p>
            </div>

            <p className="mx-auto mt-6 max-w-xl border-t border-blue-100 pt-6 text-center text-blue-900/75" data-id="element-196" data-mp="2rl06f32dvfxq">
              {kitOffer.closing}
            </p>
          </div>
        </div>
      </div>
    </section>;
}